import { takeLatest } from 'redux-saga/effects';
import { handleApiRequest } from '../utils/sagaUtils';
import {apiCall} from "../utils/api";
import {getOrganizationsFailure, getOrganizationsSuccess} from "../actions/organizationActions";
import {GET_ORGANIZATIONS_REQUEST} from "../constants/organizationActionTypes";

const getOrganizations = (data) => {
    return apiCall(`${process.env.REACT_APP_API_URL}/organization-api/getOrganizations`, 'POST', data);
}

function* getOrganizationsSaga(action) {
    yield* handleApiRequest(action, getOrganizations, getOrganizationsSuccess, getOrganizationsFailure);
}

export default function* watchOrganizationSaga() {
    yield takeLatest(GET_ORGANIZATIONS_REQUEST, getOrganizationsSaga);
}